export const CERTIFICATE_LIST = 'CERTIFICATE_LIST';
export const CERTIFICATE_DETAILS = 'CERTIFICATE_DETAILS';
//certificate/listing?from=${pagination}&to=${to}
